var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('salesPayment-form',{attrs:{"loading":_vm.loading,"salesPaymentData":_vm.salesPayment,"formErrors":_vm.formErrors},on:{"salesPaymentSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }